import Bottle from "bottlejs";
import Intl from "intl";
import {
    AssetManager,
    CatalogManager,
    Garage,
    ModelManager,
    ProfileManager,
    BikeGeometryManager,
    FormSubmissionManager
} from "./managers";
import {
    Localization,
    FormSubmission
} from "./services";


// create bottle
const bottle = new Bottle();

// constants
bottle.constant("Intl", Intl);

//services
bottle.service("localization", Localization);
bottle.service("formSubmission", FormSubmission, "profileManager");

// managers
bottle.service("profileManager", ProfileManager, "localization", "Intl");
bottle.service("catalogManager", CatalogManager, "profileManager", "assetManager");
bottle.service("garage", Garage, "catalogManager");
bottle.service("assetManager", AssetManager, "profileManager");
bottle.service("modelManager", ModelManager, "assetManager");
bottle.service("formSubmissionManager", FormSubmissionManager, "localization", "formSubmission", "profileManager");

// export
const di = bottle.container;
export {di};


// WEBPACK FOOTER //
// ./src/bottle.js